import Api from "../config/Axios";


export const getListingService = (token, user_id, param, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/web-config${param}`, {params: data, ...config});
};

export const getBulkListingService = (token, user_id, param, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/web-config-bulk${param}`, {params: data, ...config});
};

export const patchEdit = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.patch(`api/web/web-config/bulk-update`, data, config);
};

/* Site config api */
export const getStackingLimitSiteConfig = async (data, token, user_id) => {
    const config = {
      headers: {
        Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
        UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
      },
    };
    return Api.get(`api/web/web-config?slug=${data}`, config);
};

/* Site config api */
export const updateStackingLimitSiteConfig = async (data, token, user_id) => {
    const config = {
      headers: {
        Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
        UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
      },
    };
    return Api.patch(`api/web/web-config/update`,data ,config);
};

/* Site config api */
export const updateOrderStatusChangeLimitSiteConfig = async (data, token, user_id) => {
    const config = {
      headers: {
        Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
        UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
      },
    };
    return Api.patch(`api/web/web-config/update`,data ,config);
};

export const updateShiftStartWalletThresholdSiteConfig = async (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/web-config/update`,data ,config);
};

export const updateSiteConfigCommonFunction = async (data, token, user_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/web-config/update`,data ,config);
};

export const getConfigDev = (type, token, user_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/config-dev/${type}`, config);
};

export const updateConfigDev = (type, data, token, user_id) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/config-dev/${type}`, data, config);
};